const styles = {
  input: {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "white !important",
    },
    borderRadius: "10px",
  },
};
export default styles;
